import { render, staticRenderFns } from "./CommentCriteria.vue?vue&type=template&id=2ef4243b&scoped=true&"
import script from "./CommentCriteria.vue?vue&type=script&lang=js&"
export * from "./CommentCriteria.vue?vue&type=script&lang=js&"
import style0 from "./CommentCriteria.vue?vue&type=style&index=0&id=2ef4243b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef4243b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VTextField})
